import { render } from "./CartColumn.vue?vue&type=template&id=f1875dce&scoped=true"
import script from "./CartColumn.vue?vue&type=script&lang=js"
export * from "./CartColumn.vue?vue&type=script&lang=js"

import "./CartColumn.vue?vue&type=style&index=0&id=f1875dce&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f1875dce"

export default script